import { cn } from "@/lib/utils";

interface BrandNameProps {
  className?: string;
}

/**
 * Brand wordmark: "Love" in foreground (white in dark mode) + "Rank" in primary green.
 * Use wherever the brand name appears as a logo or heading.
 */
const BrandName = ({ className }: BrandNameProps) => (
  <span className={cn("inline-flex items-baseline", className)}>
    <span className="text-foreground">Orbit</span>
    <span className="text-primary">Rank</span>
  </span>
);

export default BrandName;
